import { api } from "../Apis/interceptor";

//Control Panel
export const getUser = function (id, customer_id, branch) {
  return api.get(
    "/api/v1/users/" +
      id +
      "/" +
      customer_id +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key
  );
};
//Admin End
export const getuserbyid = function (id) {
  return api.get("/api/v1/users/" + id);
};

export const all = function (cust_id, sortBy, orderBy, branch) {
  return api.get(
    "/api/v1/user/" +
      cust_id +
      "/" +
      sortBy +
      "/" +
      orderBy +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key
  );
};

export const getAllUsers = function (
  cust_id,
  username,
  searchVal,
  dateRange,
  sortBy,
  orderBy,
  skip,
  limit,
  branch
) {
  return api.get(
    "/api/v1/getAllUsers/" +
      cust_id +
      "/" +
      username +
      "/" +
      searchVal +
      "/" +
      dateRange +
      "/" +
      sortBy +
      "/" +
      orderBy +
      "/" +
      skip +
      "/" +
      limit +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key
  );
};

export const getLogDetails = function (id) {
  return api.get("/api/v1/getLogDetails/" + id);
};
export const allAdmin = function (customer_id) {
  return api.get("/api/v1/usersAdmin/", {
    params: { customer_id: customer_id },
  });
};

export const filter = function (
  skip,
  limit,
  cust_id,
  pattern,
  sortBy,
  orderBy,
  branch
) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/users_filter", {
    params: {
      skip: skip,
      limit: limit,
      cust_id: cust_id,
      pattern: pattern,
      sortBy: sortBy,
      orderBy: orderBy,
      branch_id: branch.branch_id,
      branch_key: branch.branch_key,
    },
  });
};

export const PrevNextPage = function (
  skip,
  limit,
  cust_id,
  username,
  sortBy,
  orderBy
) {
  return api.get("/api/v1/PrevNextPage", {
    params: {
      skip: skip,
      limit: limit,
      cust_id: cust_id,
      username: username,
      sortBy: sortBy,
      orderBy: orderBy,
    },
  });
};

export const getFilteredUsageLog = function (
  skip,
  limit,
  cust_id,
  username,
  dateRange,
  sortBy,
  orderBy,
  branch
) {
  return api.get(
    "/api/v1/filterUsageLog/" +
      cust_id +
      "/" +
      username +
      "/" +
      dateRange +
      "/" +
      sortBy +
      "/" +
      orderBy +
      "/" +
      skip +
      "/" +
      limit +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key
  );
};

export const filterAdmin = function (skip, limit, pattern, customer_id) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/usersAdmin_filter", {
    params: {
      skip: skip,
      limit: limit,
      pattern: pattern,
      customer_id: customer_id,
    },
  });
};

export const create = function (userData) {
  return api.post("/api/v1/users/", userData);
};
//Admin end
export const update = function (id, userData) {
  return api.put("/api/v1/users/" + id, userData);
};

//Control Panel
export const updateUser = function (id, customer_id, branch, userData) {
  return api.put(
    "/api/v1/users/" +
      id +
      "/" +
      customer_id +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key,
    userData
  );
};

export const getPageLikeAdmin = function (pattern) {
  return api.get("/api/v1/usersAdminLike/" + pattern);
};

export const delete1 = function (id) {
  return api.delete("/api/v1/users/" + id);
};

export const getPageLike = function (
  pattern,
  cust_id,
  sortBy,
  orderBy,
  branch
) {
  return api.get(
    "/api/v1/usersLike/" +
      pattern +
      "/" +
      cust_id +
      "/" +
      sortBy +
      "/" +
      orderBy +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key
  );
};

export const multiDelete = function (ids) {
  return api.delete("/api/v1/userMultiDelete", {
    params: {
      id: ids,
    },
  });
};

export const getUserByRole = function (cust_id, role_name, branch_id) {
  return api.get("/api/v1/userByRole", {
    params: { cust_id: cust_id, role_name: role_name, branch_id: branch_id },
  });
};

export const changeCredential = function (username, curPassword, newPassword) {
  return api.put("/api/v1/changeCredential", {
    username: username,
    curPassword: curPassword,
    newPassword: newPassword,
  });
};

export const saveEmailNotification = function (
  cus_id,
  user_id,
  email_id,
  id,
  role,
  data
) {
  return api.put(
    "/api/v1/saveEmailNotification/" +
      cus_id +
      "/" +
      user_id +
      "/" +
      email_id +
      "/" +
      id +
      "/" +
      role,
    data
  );
};
// getEmailSelectionSlot
export const getEmailSelectionSlot = function (user_id) {
  return api.get("/api/v1/getEmailSelectionSlot/" + user_id);
};

export const getUserByName = function (user_name) {
  return api.get("/api/v1/getUserByName/" + user_name);
};

export const changePassword = function (id, resetData) {
  return api.get("/api/changePassword/", {
    params: { user_id: id, resetData: resetData },
  });
};

export const userCheck = function (userData) {
  return api.get("/api/userCheck/", { params: { userData: JSON.stringify(userData) } });
};

export const updatePrivileges = function (cust_id, userData) {
  return api.put("/api/v1/updatePrivileges/" + cust_id, userData);
};

export const bySeqId = function (
  page,
  searchVal,
  cust_id,
  sortBy,
  orderBy,
  branch
) {
  return api.get(
    "/api/v1/user/bySeqId/" +
      page +
      "/" +
      searchVal +
      "/" +
      cust_id +
      "/" +
      sortBy +
      "/" +
      orderBy +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key
  );
};

export const userSearch = function (cust_id, searchVal) {
  return api.get("/api/v1/userSearch/" + searchVal + "/" + cust_id);
};

export const statusUpdate = function (updatedUsers) {
  return api.put("/api/v1/statusUpdate", updatedUsers);
};

export const tokenUpdate = function (username) {
  return api.post("/api/v1/updtTokenWithNeWPrvlgs", { username: username });
};
export const getBranchUser = function (customer_id, branch_id) {
  return api.get("/api/v1/getBranchUser/" + customer_id + "/" + branch_id);
};
export const getTeamByBranch = function (user_id) {
  return api.get("/api/v1/getTeamByBranch/" + user_id);
};
export const userPrivilleges = function () {
  if (localStorage.getItem("enduser")) {
    var user = JSON.parse(localStorage.getItem("enduser"));
    return {
      isAdmin: user.isAdmin,
      isBranchAdmin: user.isBranchAdmin,
      isRestricted: user.isRestricted,
      accept_gdpr: user.accept_gdpr,
    };
  }
};

export const getUsersList = function (cust_id, branch) {
  return api.get(
    "/api/v1/getUsersList/" +
      cust_id +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key
  );
};

export const getBidUsersList = function (cust_id, branch) {
  return api.get(
    "/api/v1/getBidUsersList/" +
      cust_id +
      "/" +
      branch.branch_id +
      "/" +
      branch.branch_key
  );
};

export const getOppUsers = function (userIds) {
  return api.post("/api/v1/getOppUsers", userIds);
};

export const exportUsageLog = function (usageLog, username) {
    window.open(`${process.env.REACT_APP_BACKEND_URL}/api/v1/exportUsageLog?username=${username}&whereClause=${usageLog}`)
}
export const updateGDPR = function (id) {
  return api.put("/api/v1/updateGDPR/" + id);
};
/*Create User From admin panel for SaaS plan*/
export const saasUser = function (userData) {
  return api.post("/api/v1/saasUser/", userData);
};
/*From admin end when the user created for free or individual plan*/
export const updateRolePermissions = function (cust_id, user_id, role_name) {
  return api.put("/api/v1/updateRolePermissions/" + cust_id + "/" + user_id, {
    role_name: role_name,
  });
};
/*From admin end - Gets the user last 30 days actions*/
export const getActivityDetails = function (id) {
  return api.get("/api/v1/getActivityDetails/" + id);
};
/*From application control panel end - Gets the users activity details*/
export const getActivityDetailsUsagelogs = function (cust_id) {
  return api.get("/api/v1/getActivityDetailsUsagelogs/" + cust_id);
};
